import { Link, LinkProps } from "@chakra-ui/react";

import { NavLink } from "react-router-dom";

type NavLinkProps = LinkProps & {
  isActive?: boolean;
  exact?: boolean;
  to: string;
};

export const NavLinks = (props: NavLinkProps) => {
  const { isActive, ...rest } = props;
  return (
    <Link
      as={NavLink}
      display="block"
      py={2}
      px={3}
      color="palmNetwork.100"
      borderBottom="4px solid transparent"
      transition="all 0.3s"
      lineHeight="1.25rem"
      aria-current={isActive ? "page" : undefined}
      _hover={{
        borderBottom: "4px solid",
        borderBottomColor: "palmNetwork.300",
        color: "palmNetwork.100",
        // backgroundColor: "palmNetwork.300",
      }}
      css={{
        "&[aria-current='page']": {
          borderBottom: "4px solid",
          borderBottomColor: "var(--chakra-colors-palmNetwork-100)",
          color: "var(--chakra-colors-palmNetwork-100)",
        },
      }}
      {...rest}
    />
  );
};
